// Chat branch step 2 — consent & connect (overhaul §6.2). The happy path reuses the shared
// ConsentModal (extracted from the Sources page) so the consent surface — the future/past
// checkboxes and the "future required" guard — is identical, then runs the shared
// connectChatSource dispatch. A connect failure shows an explicit retry panel (reskinned to
// the .wiz vocab) rather than silently advancing.

import { useState } from 'react';
import { ConsentModal } from '../shared/ConsentModal';
import { connectChatSource, ExtensionRequiredError, type ChatSourceId } from '../../lib/connect-source';
import { siteLabel } from '../../lib/sites';

export function ChatConsentStep({ sourceId, onConnected, onCancel }: {
  sourceId: ChatSourceId;
  onConnected: () => void;
  onCancel: () => void;
}) {
  const [error, setError] = useState<Error | null>(null);

  const confirm = async (consentFuture: boolean, consentPast: boolean) => {
    try {
      await connectChatSource({ sourceId, consentFuture, consentPast });
      onConnected();
    } catch (e) {
      setError(e instanceof Error ? e : new Error('Failed to connect. Please try again.'));
    }
  };

  if (error) {
    // bug-207: when the connect was blocked because the extension isn't installed/connected,
    // the primary action is to install it — link straight to the Chrome Web Store.
    const installUrl = error instanceof ExtensionRequiredError ? error.installUrl : null;
    return (
      <>
        <div className="crumb">STEP 02 · CONNECT</div>
        <div className="wh">Couldn't connect {siteLabel(sourceId)}</div>
        <p className="wp">{error.message}</p>
        <div className="wiz-foot">
          {installUrl ? (
            <>
              <a className="btn btn-primary" href={installUrl} target="_blank" rel="noopener noreferrer">
                Install the Terum extension
              </a>
              <button className="btn btn-secondary" onClick={() => setError(null)}>Try again</button>
              <a style={{ cursor: 'pointer', color: 'var(--inkS)', fontSize: 13 }} onClick={onCancel}>← Back to sources</a>
            </>
          ) : (
            <>
              <button className="btn btn-primary" onClick={() => setError(null)}>Try again</button>
              <button className="btn btn-secondary" onClick={onCancel}>← Back to sources</button>
            </>
          )}
        </div>
      </>
    );
  }

  return <ConsentModal sourceId={sourceId} onConfirm={confirm} onCancel={onCancel} />;
}
